import { type ComponentProps, type ComponentType, useCallback } from 'react';

import type { DialogsContainerProps } from '@confluence/dialogs/entry-points/DialogsStateContainer.ts';
import { useDialogs } from '@confluence/dialogs/entry-points/useDialogs.ts';

import { AgentsAwarenessModalLoadable } from '../entry-points/AgentsAwarenessModalLoadable.ts';

import type { AgentsAwarenessModalConnectedProps } from './AgentsAwarenessModalConnected.tsx';

export type OpenAgentsAwarenessModalOptions = Pick<
	AgentsAwarenessModalConnectedProps,
	'initialStep'
>;

export const useOpenAgentsAwarenessModal = (): ((
	options?: OpenAgentsAwarenessModalOptions,
) => void) => {
	const { showModal } = useDialogs();

	return useCallback(
		(options = {}) => {
			showModal(
				AgentsAwarenessModalLoadable as ComponentType<
					ComponentProps<typeof AgentsAwarenessModalLoadable> & DialogsContainerProps
				>,
				{
					...options,
					messageType: 'transactional',
				},
			);
		},
		[showModal],
	);
};
